import React, { useContext, useState, useEffect } from 'react'
import "./News.css"
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import { LanguageContext } from '../Language/LanguageContext'
import { Row, Col, Button, Pagination, Form } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import { listNews, deleteNews } from '../Network/News'
import { listCompany } from '../Network/Company'
import { baseURL } from '../Network/Config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper, faPen, faTrash, faWalking, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { Container, Loading, Toggle } from '../Library'
import TypeBadge from './TypeBadge'
import dayjs from 'dayjs'
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from '../Role/RoleContext'
import { AuthContext } from '../Auth/AuthContext'
import { AlertModalContext } from '../Library/AlertModalContext'

function News() {
    const history = useHistory()
    const alertModal = useContext(AlertModalContext)
    const auth = useContext(AuthContext)

    const role = useContext(RoleContext)
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"

    const globalRole = role.checkPermission(prefixAuthority, globalAuthority)
    const notify = useContext(NotifyContext)
    const [firstLoad, setFirstLoad] = useState(true)
    const [isLoading, setLoading] = useState(false)
    const [page, setPage] = useStateWithCallbackLazy(1)
    const size = 12
    const [isGlobal, setGlobal] = useStateWithCallbackLazy(globalRole)
    const [news, setNews] = useState([])
    const [company, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("")
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news
    const [lastLength, setLastLength] = useState(0)

    const fetchData = (page, size, isGlobal, companyId, loadnew) =>{
        setLoading(true)
        listNews(page, size, isGlobal, companyId,
            (data)=>{
                if(loadnew){
                    setNews(data)
                    if(firstLoad){
                        setFirstLoad(false)
                    }
                    setLastLength(data.length)
                }else{
                    data.map((item)=>{
                        setNews(oldData => [...oldData, item])
                    })
                    setLastLength(data.length)
                }
                
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
                notify.showNotify("Something wrong", error.message, 2)
            }
        )
    }

    const fetchCompany = () =>{
        listCompany(
            (data)=>{
                setCompany(data)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            }
        )
    }

    const deleteNewsFromList = (newsId) =>{
        alertModal.setTitle(lang.delete_news)
        alertModal.setDescription(lang.confirm_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    deleteNews(newsId,
                        ()=>{
                            notify.showNotify(lang.success_delete, lang.success_delete_desc, 0)
                            fetchData(1, size * page, isGlobal, selectedCompany, true)
                        },
                        (error)=>{
                            setLoading(false)
                            notify.showNotify("Something wrong", error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)

        // if(window.confirm(lang.confirm_delete)){
        //     setLoading(true)
        //     deleteNews(newsId,
        //         ()=>{
        //             notify.showNotify(lang.success_delete, lang.success_delete_desc, 0)
        //             fetchData(1, size * page, isGlobal, selectedCompany, true)
        //         },
        //         (error)=>{
        //             setLoading(false)
        //             notify.showNotify("Something wrong", error.message, 2)
        //         })
        // }
    }

    const prevPage = () =>{
        setPage(page - 1, (current)=>{
            fetchData(current, size, isGlobal, selectedCompany, true)
        })
    }

    const nextPage = () =>{
        setPage(page + 1, (current)=>{
            fetchData(current, size, isGlobal, selectedCompany, true)
        })
    }

    const loadMore = () =>{
        var nextPage = page + 1
        fetchData(nextPage, size, isGlobal, selectedCompany, false)
        setPage(nextPage)
    }

    const onScroll = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(lastLength >= size){
                loadMore()
            }
        }
    }
    
    useEffect(() => {
        auth.obtainUser()
        setDocumentTitle("News")
        fetchCompany()
        if(!role.checkPermission(prefixAuthority, companyAuthority)){
            let companyId = parseInt(localStorage.getItem("company_id"))
            setSelectedCompany(companyId)
            fetchData(page, size, false, localStorage.getItem("company_id"), true)
        }else if(!role.checkPermission(prefixAuthority, globalAuthority)){
            fetchData(page, size, false, selectedCompany, true)
        }else{
            fetchData(page, size, true, "", true)
        }
    }, [])

    return (
        <Container topbarTitle={langCx.lang.sidebar.news}>
        { isLoading ? <Loading/>: null }
        <div id="news">
            {/* <div className="title-header">{lang.news}</div> */}
            <div className="mid-bar">
                { role.checkPermission("_MENU_", "app.news_add") ?
                <Button
                style={{height: "100%"}}
                onClick={()=>history.push("/news/create")}
                >
                    {lang.create_news}
                </Button>
                : <div></div>
                }
                <div style={{display: 'flex', alignItem: 'center'}}>
                    <div className="public-toggle">
                        { !isGlobal ?
                        <Form.Control as="select" style={{width:150}}
                        value={selectedCompany}
                        disabled={!role.checkPermission(prefixAuthority, companyAuthority)}
                        onChange={(e)=>{
                            let companyId = e.target.value

                            if(companyId !== ""){
                                setSelectedCompany(parseInt(companyId))
                                setPage(1)
                                fetchData(1, size, false, companyId, true)
                            }else{
                                setSelectedCompany(companyId)
                                setPage(1)
                                fetchData(1, size, false, companyId, true)
                            }
                        }}>
                            <option value={""}>{lang.all_company}</option>
                            { company.map((item, key)=>
                            <option value={item.id} key={key}>{item.name}</option>
                            )}
                        </Form.Control>
                        : null
                        }
                        { role.checkPermission(prefixAuthority, globalAuthority) ?
                        <>
                        <div className="label" style={{marginLeft: 20}}>{lang.public}</div>
                        <Toggle
                        isTurnon={isGlobal}
                        onChange={()=>{
                            setGlobal(!isGlobal ? true:false,(current)=>{
                                setPage(1)
                                fetchData(1, size, current, "", true)
                            })
                        }}
                        />
                        </>
                        : null
                        }
                    </div>
                    
                    {/* <Pagination>
                        <Pagination.Prev
                        disabled={page === 1}
                        onClick={()=>prevPage()}
                        />
                        <Pagination.Item disabled>
                            {page}
                        </Pagination.Item>
                        <Pagination.Next
                        disabled={news.length < size}
                        onClick={()=>nextPage()}
                        />
                    </Pagination> */}
                </div>
            </div>
            <div className="news-container" onScroll={onScroll}>
                <Row>
                    { news.map((item, key) =>
                    <Col sm={6} lg={4} key={key}>
                        <NewsItem
                        to={"/news/view/"+item.id}
                        image={item.thumbnailImagePath}
                        title={item.title}
                        date={item.publishDate}
                        type={item.type}
                        createDate={item.createdDate}
                        expiredDate={item.expiredDate}
                        isExpired={new Date() > item.expiredDate ? true : false}
                        isShowVisitor={item.isShowVisitor}
                        isShowInformationScreen={item.isShowInformationScreen}
                        onClickEdit={(e)=>{
                            e.preventDefault()
                            history.push({
                                pathname: "/news/edit/"+item.id,
                                state: { data: item }
                            })
                        }}
                        onClickDelete={(e)=>{
                            e.preventDefault()
                            deleteNewsFromList(item.id)
                        }}
                        />
                    </Col>
                    )}
                </Row>
                { news.length === 0 ?
                <div className="no-news">
                    <FontAwesomeIcon icon={faNewspaper} className="icon"/>
                    <div>
                        {lang.no_news}
                    </div>
                </div>
                : null
                }
                {/* In case broswer not auto loading more */}
                <div style={{ textAlign: 'center' }}>
                    { lastLength >= size ?
                    <Button onClick={()=>loadMore()}>
                        {lang.load_more}
                    </Button>
                    : null
                    }
                </div>
            </div>
        </div>
        </Container>
    )
}

function NewsItem(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news

    const convertDate = (toDate) =>{
        let date = new Date(toDate)
        let formattedDate = dayjs(date).format("D MMM YYYY - H:mm")
        return formattedDate
    }

    return(
        <Link 
        to={props.to}
        className="news-item">
            <div className='mark-container'>

            
                { props.isShowVisitor ?
                <div className="mark-visitor" title={lang.show_visitor}>
                    <FontAwesomeIcon icon={faWalking} color={"white"}/>
                </div>
                : null
                }
                { props.isShowInformationScreen ?
                <div className="mark-information" title={lang.screen_display}>
                    <FontAwesomeIcon icon={faWindowMaximize} color={"white"}/>
                </div>
                : null
                }
            </div>
            <div className="image">
                { props.image !== null ?
                <img src={baseURL + props.image} alt="thumbnail-image"/> :
                <FontAwesomeIcon icon={faNewspaper}/>
                }
            </div>
            <div className="content">
                <div className="title">
                    {props.title}
                </div>       
                {/* <div className="desc">
                    {lang.create} : {convertDate(props.createDate)}
                </div> */}
                <div className="desc">
                    {lang.publish} : {convertDate(props.date)}
                </div>
                <div className='desc'>
                    {lang.expire_date} : {convertDate(props.expiredDate)}
                </div>
                { props.isExpired ?
                <div className="expired-badge">
                    {lang.expired}
                </div>
                : null
                }
                <div className="bottom-item">
                    <TypeBadge type={props.type}/>
                    <div>
                        <Button
                        size="sm"
                        onClick={props.onClickEdit}
                        >
                            <FontAwesomeIcon icon={faPen}/>
                        </Button>
                        <Button
                        size="sm"
                        variant="danger"
                        style={{marginLeft: 10}}
                        onClick={props.onClickDelete}
                        >
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default News